import { commonWebSocket } from '@services/common/common.constants';
import { createReducer } from 'redux-act';

const defaultState = {
  offers: [],
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.OFFER_SNAPSHOT, (state:any, payload:any) => {
    if (Array.isArray(payload?.offers)) {
      return {
        ...state,
        offers: payload.offers.filter((offer: any) => offer && typeof offer === "object"),
      };
    }
    return state;
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/offer/offer.reducer.ts